import { exact, string } from "prop-types";

export const itemType = exact({
  id: string,
  label: string,
});
